module.exports = __webpack_public_path__ + "static/media/001.89fc7709.jpg";